import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Route } from '@angular/router';

import { UploadZipComponent } from './components/upload-zip/upload-zip.component';
import { UploadFileComponent } from './components/upload-file/upload-file.component';
import { ModalComponent } from './components/upload-modal-window/upload-modal-window.component';
import { IdentifyAssetsWrapperComponent } from './components/identify-assets-wrapper/identify-assets-wrapper.component';
import { CoreModule } from '../core/core.module';
import { IdentifyAssetsModule } from '../../identify-assets/identify-assets.module';
import { SummaryWrapperComponent } from './components/summary-wrapper/summary-wrapper.component';
import { SummaryModule } from '../../summary/summary.module';

import { FslGuard } from './guards/fsl-guard';
import { UploadHistoryWrapperComponent } from './components/upload-history-wrapper/upload-history-wrapper.component';
import { UploadHistoryModule } from '../../upload-history/upload-history.module';
import { ViewAssetsModule } from '../../view-assets/view-assets.module';
import { UploadKeymapFileComponent } from './components/upload-keymap-file/upload-keymap-file.component';
import { SiteProfileWrapperComponent } from './components/site-profile-wrapper/site-profile-wrapper.component';
import { SiteProfileModule } from '../../site-profile/site-profile.module';
import { DeactivateGuardService } from './guards/deactivate-guard';
import { AssetDiscoveryWrapperComponent } from './components/asset-discovery-wrapper/asset-discovery-wrapper.component';
import { AssetDiscoveryModule } from '../../asset-discovery/asset-discovery.module';
import { RawDataDiscoveryWrapperComponent } from './components/raw-data-discovery-wrapper/raw-data-discovery-wrapper.component';
import { RawDataDiscoveryModule } from '../../raw-data-discovery/raw-data-discovery.module';
import { CriticalErrorModelAbsentComponent } from '../../context-discovery-services/component/critical-error-model-absent/critical-error-model-absent.component';
import { CriticalErrorApiFailureComponent } from '../../context-discovery-services/component/critical-error-api-failure/critical-error-api-failure.component';
import { ErrorHandlerTemplateComponent } from '../../context-discovery-services/component/error-handler-template/error-handler-template.component';
import { LanguageSelectorComponent } from './components/language-selector/language-selector.component';
import { UploadLanguageSelectorComponent } from './components/upload-language-selector/upload-language-selector.component';


const routing: Route[] = [

      { path: '', component: UploadZipComponent, canActivate: [FslGuard] },
      { path: 'upload', component: UploadZipComponent, canDeactivate: [DeactivateGuardService] },
      { path: 'identify-assets', component: IdentifyAssetsWrapperComponent },
      { path: 'summary', component: SummaryWrapperComponent },
      { path: 'upload-history', component: UploadHistoryWrapperComponent },
      { path: 'site-profile', component: SiteProfileWrapperComponent },
      { path: 'asset-discovery', component: AssetDiscoveryWrapperComponent },
      { path: 'model-error', component: CriticalErrorModelAbsentComponent},
      { path: 'error', component: CriticalErrorApiFailureComponent},
      { path: 'raw-data-discovery', component: RawDataDiscoveryWrapperComponent}
    ];



@NgModule({
  imports: [
    RouterModule.forRoot(routing),
    CommonModule,
    IdentifyAssetsModule,
    CoreModule,
    SummaryModule,
    UploadHistoryModule,
    ViewAssetsModule,
    SiteProfileModule,
    AssetDiscoveryModule,
    RawDataDiscoveryModule
  ],
  declarations: [
    UploadZipComponent,
    UploadFileComponent,
    ModalComponent,
    IdentifyAssetsWrapperComponent,
    SummaryWrapperComponent,
    UploadHistoryWrapperComponent,
    UploadKeymapFileComponent,
    SiteProfileWrapperComponent,
    AssetDiscoveryWrapperComponent,
    RawDataDiscoveryWrapperComponent,
    CriticalErrorModelAbsentComponent,
    CriticalErrorApiFailureComponent,
    ErrorHandlerTemplateComponent,
    LanguageSelectorComponent,
    UploadLanguageSelectorComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [
    RouterModule,
    UploadZipComponent,
    IdentifyAssetsWrapperComponent,
    LanguageSelectorComponent
  ]
})
export class FslModule { }
export { UploadZipComponent, IdentifyAssetsWrapperComponent, LanguageSelectorComponent };
